import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {first} from 'rxjs/operators';
import {ClipsService} from '../../../../modules/clips/clips.service';
import {Store} from '@ngxs/store';
import {PlayerState} from '../../../../store/player.state';

@Component({
  selector: 'gg-create-clip',
  templateUrl: './create-clip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateClipComponent implements OnInit {
  constructor(private clipsService: ClipsService, private store: Store) {
  }

  ngOnInit() {
  }

  async createClip() {
    const src = await this.store.select(state => state.player.src).pipe(first()).toPromise();
    this.clipsService.createClip(src);
  }

}
